import type * as React from 'react';
import { get } from '@Domain/Api';
import accountMetricsFetched, {
	type AccountMetricsFetchedAction,
	type AccountMetricsFetchedPayload,
} from '@Application/AccountMetrics/Actions/accountMetricsFetched';
import accountMetricsFetchFailed, {
	type AccountMetricsFetchFailedAction,
} from '@Application/AccountMetrics/Actions/accountMetricsFetchFailed';
import type FetchAccountMetrics from '@Application/AccountMetrics/Queries/FetchAccountMetrics';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = AccountMetricsFetchedAction | AccountMetricsFetchFailedAction;

export default (query: FetchAccountMetrics) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<AccountMetricsFetchedPayload>(
				`${parameters.api.host}/api/accounts/${query.accountId}/metrics`,
			);

			const action = accountMetricsFetched(payload, query.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = accountMetricsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
